﻿/// <reference path="smartcenter.module.ts" />

module Meevo.Plugins.SmartCenter {

  // TODO: Move supporting classes and enums to appropriate file

  import SmartCenterSmartTile = Meevo.Model.SmartCenterSmartTile;
    import SmartTileParameters = Meevo.Model.SmartTileParameters;
    import IncludedEmployeeEnum = Meevo.Model.IncludedEmployeeEnum;

    export enum TileTypes {
    Data = 30073,
    Shortcut = 30074,
    Image = 30075
  }

  export enum TileShortcutType {
    Convo,
    Url
  }

    export class SmartCenterSmartTileModel implements  SmartCenterSmartTile {
        id: number;
        smartCenterTileId: Guid;
        rowPosition?: number;
        columnPosition?: number;
        rowSpan: number;
        columnSpan: number;
        parameter: string;
        backgroundColor: string;
        image?: string;
        displayName: string;
        displayNameOverride: string;
        smartTileTypeEnum: Meevo.Plugins.SmartCenter.TileTypes;
        includedEmployee: number;
        parsedParameters: SmartTileParameters;
        smartTileName?: string;
        hasExtendedData?: boolean;
        lastUpdated?: Date;
        tileAvailabilityLevel?: number;
        desc?: string;

        private initialRowPosition: number;
        private initialColumnPosition: number;

        get isInitialPositionChanged(): boolean {
            return this.initialRowPosition !== this.rowPosition
                || this.initialColumnPosition !== this.columnPosition;
        }

        constructor(props: SmartCenterSmartTile = <SmartCenterSmartTile>{}) {
            _.assign(this, props);

            this.setInitialPositions();
        }

        public setInitialPositions() {
            this.initialRowPosition = this.rowPosition;
            this.initialColumnPosition = this.columnPosition;
        }
    }

  export class TileItem {

    public id: number;

    public rowspan: number;

    public colspan: number;

    public tileType: TileTypes;

    public title: string;

    public smartTileName: string;

    public shortcut: string;

    public shortcutType: TileShortcutType;

    public background: string;

    public image: string;

    public isData: boolean;

    public isImage: boolean;

    public isShortcut: boolean;

    public value: number | string = 0;

    public hasExtendedData: boolean = false;

    public extendedDataTemplateKey: string;

    public smartCenterTile_TId: Guid;

    public lastUpdated: Date;

    public charLength: number;

    public includedEmployee;

    public cacheExpirationMinutes: number;

    public shouldShowRefreshInfo: boolean = true;

    public parameter: string;

    public locationDisplay: string;

    public showExtendedDetail: boolean;  

    constructor(id: number, rowspan: number, colspan: number, tileType: TileTypes, background: string, title?: string, shortcut?: string, image?: string, shortcutType?: TileShortcutType, charLength?: number, includedEmployee?: any) {
      this.id = id;      
      this.rowspan = rowspan;
      this.colspan = colspan;
      this.tileType = tileType;
      this.background = background;
      this.title = title;
      this.shortcut = shortcut;
      this.shortcutType = shortcutType;
      this.image = image;
      this.charLength = charLength;
      this.includedEmployee = includedEmployee;

      // Create bools to use in view so that enum evaluation is done here
      this.isData = tileType == TileTypes.Data;
      this.isImage = tileType == TileTypes.Image;
      this.isShortcut = tileType == TileTypes.Shortcut;
    }
  }

  export class TileSet {

    public id: Guid;

    public title: string;

    public tiles: Array<TileItem> = [];

    constructor(id: Guid, title: string) {
      this.id = id;
      this.title = title;
    }

  }

  export class TileData {

    public smartCenterTile_TId: Guid;

    public value: number;

    public lastUpdatedUtc: string;

    public cacheExpirationMinutes: number;

    public locationDisplay: string;

    public id?: number;

    constructor(smartCenterTile_TId: Guid, value: number) {
      this.smartCenterTile_TId = smartCenterTile_TId;
      this.value = value;
    }

  }

  export class SmartCenterService {  

    private $q: ng.IQService;
    private dataService: Meevo.Components.Common.ICommonDataService;

    constructor(appSettings: Meevo.Components.Common.IAppSettings,
      dataService: Meevo.Components.Common.ICommonDataService,
      modalService: Meevo.Components.Modal.IModalService,
      identityService: Meevo.Components.Common.IIdentityService,
      $q: ng.IQService) {

      this.$q = $q;
      this.dataService = dataService;

    }

    public getTileSets(): ng.IPromise<Array<any>> {
      return this.dataService.getUserSmartCenters();
    }

    public getTileData(tileSet): ng.IPromise<Array<TileData>> {        
      return this.dataService.getSmartCenter(tileSet);
    }

    public getTileExtendedData(tileId): ng.IPromise<Array<any>> {
      return this.dataService.getSmartCenterExtendedData(tileId);
    }

    static factory(): Function {
      let svc = (appSettings: Meevo.Components.Common.IAppSettings,
        dataService: Meevo.Components.Common.ICommonDataService,
        modalService: Meevo.Components.Modal.IModalService,
        identityService: Meevo.Components.Common.IIdentityService,
        $q: ng.IQService) => {
        return new SmartCenterService(appSettings, dataService, modalService, identityService, $q);
      }

      svc.$inject = ["meevo.AppSettings", "meevo.components.common.DataService",
        "meevo.components.modal.ModalService", "meevo.components.common.IdentityService", "$q"];
      return svc;
    }
  }

  angular.module("meevo.plugins.smartCenter")
    .factory("meevo.plugins.smartCenter.SmartCenterService", SmartCenterService.factory());
}
